export const desktopHeaderHeight = '83px'
export const desktopPagePt = '32px'
export const desktopPagePb = '32px'
